import { Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import BsModal from "../../common/BaseModal";
import ClinicalFeasibiltyForm from "./ClinicalFeasibiltyForm";
import FinancialFeasibiltyForm from "./FinancialFeasibiltyForm";
import { useState } from "react";
import { hasAuthority } from "../../../../utils/authorities";
import { useSelector } from "react-redux";
// import { clinicalStatus, financialStatus } from "../../../../pages/appointment-details/common-pre-screen/common";
import { hasCRPermission, havingCRPatient } from '../../../../utils/utils';


const FeasibilityAlertWithModal = ({ id, feasibilityStatus, onMarkAsFisable, phase_type, requestReasons }) => {
    const { bmr_permissions, role_id } = useSelector((state) => state.loginData);
    const [open, setOpen] = useState(false);
    const [isClinical, setIsClinical] = useState(false)
    const crPermissions = useSelector((state) => state.loginData?.cr_permissions);
    const checkCRFinancial = havingCRPatient(requestReasons, ["change-financial-feasibility"])
    const checkCRClinical = havingCRPatient(requestReasons, ["change-clinical-feasibility"])
    const handleFeasibleClick = () => {
        setOpen(true);
    };
    const handleCloseModal = () => {
        setOpen(false);
    };
    return (
        <Box>
          <div className="flex justify-end mb-2 gap-2">
    {(((role_id === 1 || hasAuthority(["marked-clinical-feasible"], bmr_permissions)) &&
        feasibilityStatus?.clinical_status == 0) ||
        ((role_id === 1 || hasCRPermission(crPermissions, ['change-clinical-feasibility'], "RESOLVE")) && checkCRClinical))
        &&
        <LoadingButton
            onClick={() => { handleFeasibleClick(); setIsClinical(true); }}
            variant="contained"
            className="w-[200px] h-[40px] rounded-[6px] border-[#3571FF] p-[10px]"
            fullWidth
        >
            Mark As Clinical Feasible
        </LoadingButton>
    }
    {(((role_id === 1 || hasAuthority(["marked-financial-feasible"], bmr_permissions)) &&
        feasibilityStatus?.financial_status == 0) ||
        ((role_id === 1 || hasCRPermission(crPermissions, ['change-financial-feasibility'], "RESOLVE")) && checkCRFinancial))
        &&
        <LoadingButton
            onClick={() => { handleFeasibleClick(); setIsClinical(false); }}
            variant="contained"
            className="w-[200px] h-[40px] rounded-[6px] border-[#3571FF] p-[10px]"
            fullWidth
        >
            Mark as Financial Feasible
        </LoadingButton>
    }
</div>
            <div>
                {/* {feasibilityStatus?.clinical_status != 0&&feasibilityStatus?.clinical_status != null && hasAuthority(["marked-clinical-feasible"], bmr_permissions) &&
                    <Alert sx={{
                        bgcolor: clinicalStatus[feasibilityStatus?.clinical_status]?.bgColor,
                        color: clinicalStatus[feasibilityStatus?.clinical_status]?.text,
                        padding: '10px'
                    }}
                        severity={"success"}
                        icon={false}>
                        <span className={`text-[#00B27] font-normal font-roboto text-[12.99px] leading-[16.43px]`}>
                            Note: This Subject is marked as {clinicalStatus[feasibilityStatus?.clinical_status]?.lable}
                        </span>
                    </Alert>}
                {feasibilityStatus?.financial_status != 0 &&feasibilityStatus?.clinical_status != null && hasAuthority(["marked-financial-feasible"], bmr_permissions) &&
                    <Alert
                        sx={{
                            padding: '10px',
                            marginTop: "1rem",
                            color: financialStatus[feasibilityStatus?.financial_status]?.text,
                            bgcolor: financialStatus[feasibilityStatus?.financial_status]?.bgColor
                        }}
                        // severity={financialStatus[feasibilityStatus?.financial_status]?.color} 
                        icon={false}
                    >
                        <span className={`text-[#00B27] font-normal font-roboto text-[12.99px] leading-[16.43px]`}>
                            Note: This Subject is marked as {financialStatus[feasibilityStatus?.financial_status]?.lable}
                        </span>
                    </Alert>} */}
                
            </div>
            <BsModal open={open} onClose={handleCloseModal} title={isClinical ? "Clinical Feasibility" : "Financial Feasibility"}>
                {isClinical
                    ? <ClinicalFeasibiltyForm id={id} handleCloseModal={handleCloseModal} onMarkAsFisable={onMarkAsFisable} feasibilityInfo={feasibilityStatus} />
                    : <FinancialFeasibiltyForm phase_type={phase_type} id={id} handleCloseModal={handleCloseModal} onMarkAsFisable={onMarkAsFisable} feasibilityInfo={feasibilityStatus} />}
            </BsModal>
        </Box >
    );
}

export default FeasibilityAlertWithModal;